import {
    GUI_UPDATE,
    GUI_ONPOPSTATE_LISTENER_ADD,
    GUI_WIZARD_NEXTAUTOSTEP_WATCHER_ADD,
    GUI_WIZARD_BUTTON_NAV_CLICKED,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const dotProp = require('dot-prop-immutable');

const initialState = appInitialState.gui;

/**
 * This is the application state's gui slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  appStore.dispatch(updateGui({
 *      responsive: 'mobile'
 *  }));
 */
function guiReducer(state = initialState, action) {

    let dataPath = '';

    switch(true) {

        case (action.type === STORE_RESET):

            // only the responsive value must be kept as is when the store is reset
            const oldState = state;            
            state = {
                ...state,
                ...initialState,
                responsive: oldState.responsive
            };

            break;

        case (action.type === GUI_UPDATE):

            state = {
                ...state,
                ...action.payload
            };
            break;

        case (action.type === GUI_ONPOPSTATE_LISTENER_ADD):

            dataPath = 'onpopstateListeners';
            let listenerData = {};
            listenerData[action.payload.listenerId] = true;
            listenerData = {
                ...state.onpopstateListeners,
                ...listenerData
            };
            state = dotProp.set(state, dataPath, listenerData);
            break;

        case (action.type === GUI_WIZARD_NEXTAUTOSTEP_WATCHER_ADD):

            dataPath = 'wizardNextautoWatchers';
            let watcherData = {};
            watcherData[action.payload.listenerId] = true;
            watcherData = {
                ...state.wizardNextautoWatchers,
                ...watcherData
            };
            state = dotProp.set(state, dataPath, watcherData);
            break;

        case (action.type === GUI_WIZARD_BUTTON_NAV_CLICKED):

            dataPath = 'wizardButtonNavClicked';
            state = dotProp.set(state, dataPath, action.payload.clicked);
            break;

        default:
            
    }

    return state;
};

export default guiReducer;